import type { AppState } from '~/store/app.store';
import type {
  BoundaryGroupId, BoundaryTerritoryGroupId,
} from '~/store/boundaries/boundaryIdentifier.type';
import type {
  BoundaryFiltersState, BoundaryLocationsFiltersState,
} from '~/store/mapSettings/toolsState/boundary/mapSettingsToolsStateBoundary.state';

export const activeBoundaryToolBTGIdPerBoundaryGroupToolsStateSelector = (state: AppState): Record<BoundaryGroupId, BoundaryTerritoryGroupId> => {
  return state.map.mapSettings.data.toolsState.boundary.activeBTGIdPerBoundaryGroup;
};

export const boundaryLocationsFiltersStateSelector = (state: AppState): BoundaryLocationsFiltersState =>
  state.map.mapSettings.data.toolsState.boundary.locationsFilter;

export const boundaryFiltersStateSelector = (state: AppState): BoundaryFiltersState =>
  state.map.mapSettings.data.toolsState.boundary.filters;
